import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString } from "class-validator";
import { COST_HINT_TYPE } from "@/static/costHintTypeEnum";

export class CostHintEdit {
  @Expose()
  @IsNumber()
  @IsOptional()
  id!: number | null;
  @Expose()
  @IsEnum(COST_HINT_TYPE)
  type!: COST_HINT_TYPE;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsBoolean()
  isLocked!: boolean;

  constructor() {
    this.id = null;
    this.isLocked = false;
    this.name = "";
  }
}
